import {ColumnsType} from "antd/lib/table";
import {CategoryDto} from "../../api";
import {CrudTableWrapperProps} from "digimuth-components/dist/components/crudTable/crudTable";
import {CrudTable, nameof} from "digimuth-components/dist";
import {Button} from "antd";
import {generatePath, useNavigate} from "react-router-dom";
import {RoutingPaths} from "../routing/routingContainer";

export default function CategoriesList(props: CrudTableWrapperProps<CategoryDto>) {

    const navigate = useNavigate();

    const columns: ColumnsType<CategoryDto> = [
        {
            key: nameof<CategoryDto>("name"),
            dataIndex: nameof<CategoryDto>("name"),
            title: "Nazwa"
        },
        {
            key: nameof<CategoryDto>("description"),
            dataIndex: nameof<CategoryDto>("description"),
            title: "Opis",
            render: (category: string) => <span dangerouslySetInnerHTML={{__html: category}}/>
        }
    ];

    function onRecordClick(id: number) {
        navigate(generatePath(RoutingPaths.subcategoryTable.route, {
            categoryId: id.toString()
        }));
    }

    function onProductsClick(id: number) {
        navigate(generatePath(RoutingPaths.productsByCategoryTable.route, {
            categoryId: id.toString()
        }))
    }

    return <>
        <CrudTable
            data={props.data}
            onAddClicked={props.onAddClicked}
            onEditClicked={props.onEditClicked}
            onDeleteClicked={props.onDeleteClicked}
            isLoading={props.isLoading}
            columns={columns}
            deleteButtonTitle={"Usuń"}
            editButtonTitle={"Edytuj"}
            addButtonTitle={"+ Dodaj nową kategorie"}
            deleteConfirmMessage={"Czy na pewno chcesz usunąć tę kategorię?"}
            customRowActions={record => <>
                {/*<Button onClick={() => onRecordClick(record.id!)}>*/}
                {/*    Kategorie podrzędne*/}
                {/*</Button>*/}
                <Button onClick={() => onProductsClick(record.id!)}>
                    Produkty
                </Button>
            </>}
        />
    </>
}
